"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeType = void 0;
var EmployeeType;
(function (EmployeeType) {
    EmployeeType["EMPLOYEE"] = "EMPLOYEE";
    EmployeeType["CONTRACTOR"] = "CONTRACTOR";
})(EmployeeType || (exports.EmployeeType = EmployeeType = {}));
